import { useCallback } from 'react';
import { trpcAdmin } from './trpcAdmin';
import { djs } from '@duke-hq/djs';
import type {
  DocumentType,
  DocumentComponentProps,
} from '@duke-hq/ui/components/PdfGeneratorButton/utils';

export function useEnrolmentDocumentQuery() {
  return useCallback(
    (
      {
        documentType,
        enrolmentId,
        semester,
      }: {
        documentType: DocumentType;
        enrolmentId: number;
        semester?: number;
      },
      options: { enabled: boolean; retry: boolean },
    ): { refetch: () => Promise<{ data?: DocumentComponentProps }> } => {
      const userUTCOffset = djs().utcOffset();

      const queryResult = trpcAdmin.enrolment.getPdfDocumentData.useQuery(
        {
          documentType,
          enrolmentId,
          semester,
          userUTCOffset,
        },
        options,
      );

      return {
        refetch: async (): Promise<{ data }> => {
          const result = await queryResult.refetch();
          return { data: result.data };
        },
      };
    },
    [],
  );
}
